<template>
  <div class="wholesale-section">
    <div class="wholesale-inner">
      <div class="wholesale-text reveal">
        <span class="section-eyebrow">For Retailers</span>
        <h2 class="section-title wholesale-title">
          Wholesale<br />&amp; Trade
        </h2>
        <p class="wholesale-body">
          Are you a boutique, optician, or retailer looking to stock premium
          designer eyewear? We offer competitive wholesale pricing on our full
          range of 100% authentic frames — with no minimum order requirements to
          get started.
        </p>
        <p class="wholesale-body">
          Whether you're opening a new shop or expanding an existing collection,
          our team will work with you to find the right mix for your customers.
          <strong>Reach out and let's build something together.</strong>
        </p>
        <div class="wholesale-perks">
          <div
            v-for="(perk, i) in perks"
            :key="perk"
            class="wholesale-perk reveal"
            :class="'reveal-delay-' + ((i % 2) + 1)"
          >
            <span class="perk-icon">
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="1.8"
              >
                <polyline points="20 6 9 17 4 12"></polyline>
              </svg>
            </span>
            <span>{{ perk }}</span>
          </div>
        </div>
        <div class="wholesale-email-block">
          <span class="wholesale-email-label">Wholesale enquiries</span>
          <a class="wholesale-email-link" :href="'mailto:' + email">{{
            email
          }}</a>
        </div>
        <a
          class="btn-primary btn-yellow"
          :href="'mailto:' + email + '?subject=Wholesale%20Enquiry'"
          >Enquire About Wholesale</a
        >
      </div>
      <div class="wholesale-image reveal reveal-delay-2">
        <MediaSlotImage
          slot-code="work.wholesale"
          :fallback="image"
          alt="Designer eyewear wholesale"
          sizes="(max-width: 767px) 100vw, 50vw"
          :width="960"
          :height="1200"
        />
        <div class="wholesale-badge">
          <span class="badge-num">100%</span>
          <span class="badge-label">Authentic</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { cdnUrl } from "~/utils/cdn";
import MediaSlotImage from "~/core/components/atoms/media-slot-image/media-slot-image.vue";

export default {
  name: "WorkWithUsWholesale",
  components: { MediaSlotImage },
  props: {
    email: {
      type: String,
      default: "admin@hooliganseyewear.com",
    },
    image: {
      type: String,
      default: () => cdnUrl("/image/HOOLIGANS+WEB/Work+With+Us/3.jpg"),
    },
    perks: {
      type: Array,
      default: () => [
        "100% Authentic, in-house inventory",
        "Competitive trade pricing",
        "Dedicated account support",
      ],
    },
  },
};
</script>
